import React, { useContext } from 'react';
import { Button, Tabs } from 'antd';
import type { TabsProps } from 'antd';
import ObjectTab from './objectTab/objectTab';
import { CloseOutlined } from '@ant-design/icons';
import { ThemeContext } from 'pages/_app';
import { getTextColor } from 'src/constants/theme';
import styles from './editor-drawer.module.css';

export default function EditorDrawer({
  isOpen,
  setIsOpen,
  selectedModel,
  selectedModelProps,
  dispatchChangeModels,
  setSelectedModelProps,
}) {
  const { isDark } = useContext(ThemeContext);

  if (!selectedModel || !selectedModelProps) {
    return <></>;
  }

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: `PROPERTIES`,
      children: (
        <ObjectTab
          selectedModel={selectedModel}
          selectedModelProps={selectedModelProps}
          dispatchChangeModels={dispatchChangeModels}
          setSelectedModelProps={setSelectedModelProps}
        />
      ),
    },
    // {
    //   key: '2',
    //   label: `GEOMETRY`,
    //   children: `GEOMETRY PROPS`,
    // },
    // {
    //   key: '3',
    //   label: `MATERIAL`,
    //   children: `MATERIAL PROPS`,
    // },
  ];

  const onChange = (key: string) => {
    console.log(key);
  };

  return (
    <div
      className={`${styles.editorDrawer} container-none-flex ${
        isOpen ? 'active' : ''
      } ${isDark ? styles.darkTheme : ''}`}
    >
      <Button
        icon={
          <CloseOutlined
            style={{ fontSize: 16, color: getTextColor(isDark) }}
          />
        }
        type='link'
        onClick={() => {
          setIsOpen(() => false);
        }}
      />
      <Tabs
        defaultActiveKey='1'
        items={items}
        onChange={onChange}
        style={{ paddingLeft: '15px' }}
      />
    </div>
  );
}
